var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 184,
    fill: "#13B5EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 172C136.183 172 172 136.183 172 92C172 47.8172 136.183 12 92 12C47.8172 12 12 47.8172 12 92C12 136.183 47.8172 172 92 172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.075 77.593L115.112 67.6734V87.5126L98.075 77.593ZM115.112 120.106L92.3958 133.332L69.6792 120.106V96.9598L92.3958 110.186L115.112 96.9598V120.106ZM69.6792 67.6734L86.7167 77.593L69.6792 87.5126V67.6734ZM95.2354 82.3166L112.273 92.2362L95.2354 102.156V82.3166ZM89.5562 102.156L72.5187 92.2362L89.5562 82.3166V102.156ZM112.273 62.9497L92.3958 74.2864L72.5187 62.9497L92.3958 51.1407L112.273 62.9497ZM64 61.0603V122.94L92.3958 139L120.792 122.94V61.0603L92.3958 45L64 61.0603Z",
    fill: "#13B5EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtm);
export default __webpack_public_path__ + "static/media/ftm.1d1556faffef51f50657cec55610a380.svg";
export { ForwardRef as ReactComponent };